import { PageCustom } from '@ublique/components/Template'
import StripeTables from '@ublique/components/Template/components/StripeTables'
import React from 'react'
import Filters from '../components/Filters'
import { NS } from '../constants'
import { useTranslation } from 'react-i18next'
import useTableConfig from './hooks/useTableConfig'
// import useRoomsReset from './hooks/useRoomsReset'
import './index.scss'

function OccupazioneSpazi() {
  const { t } = useTranslation('ExtraOutput')
  const tablesConfig = useTableConfig()
  // useRoomsReset()

  return (
    <PageCustom className='occupazione-spazi'>
      <Filters title={t(`${NS}.SPACE_OCCUPANCY`)} />
      <StripeTables tables={tablesConfig} />
    </PageCustom>
  )
}

export default OccupazioneSpazi
